import { ProductAvailability } from '@types';

export const productDemo = {
    /* cspell:disable */
    name: 'Sapato de mulher',
    merchant: {
        name: 'Roma Sapatarias',
    },
    category: {
        name: 'Calçado',
    },
    availability: ProductAvailability.inStock,
    rating: 4,
    oldPrice: 35.5,
    price: 17.75,
    points: 7,
    sizes: [
        { value: 'size-1', text: 'Pequeno' },
        { value: 'size-2', text: 'Médio' },
    ],
    color: 'Bege',
    socialLinks: [
        { icon: 'fa-brands fa-facebook-f', link: 'https://www.facebook.com' },
        { icon: 'fa-brands fa-instagram', link: 'https://www.instagram.com' },
    ],
    image: { src: 'https://picsum.photos/id/1080/632/632', type: 'image/png', height: 100, width: 200 },
    images: [
        'https://picsum.photos/id/1080/632/632',
        'https://picsum.photos/id/674/632/632',
        'https://picsum.photos/id/493/632/632',
        'https://picsum.photos/id/429/632/632',
        'https://picsum.photos/id/102/632/632',
        'https://picsum.photos/id/106/632/632',
    ],
    details: `<p>
                <span class="text-muted">Material da sola:</span> Emborrachado<br />
                <span class="text-muted">Material exterior:</span> Sintético<br />
                <span class="text-muted">Material interior:</span> Sintético<br />
                <span class="text-muted">Tipo de fecho:</span> Fivela
            </p>`,
    about: '...',
    canBeAddedToCart: true,
    /* cspell:enable */
};

export const productsManagementDemo = [
    /* cspell:disable */
    {
        ref: '001',
        name: 'Sapato de mulher',
        size: '34',
        color: 'Azul',
        category: 'Calçado',
        price: 22,
        stock: ProductAvailability.inStock,
    },
    {
        ref: '002',
        name: 'Algo com um nome muito comprido tipo lorem ipsum dolor sit amet 2',
        size: '34',
        color: 'Azul',
        category: 'Calçado',
        price: 10.3,
        stock: ProductAvailability.inStock,
    },
    {
        ref: '003',
        name: 'Sapato de criança',
        size: '34',
        color: 'Azul',
        category: 'Calçado',
        price: 18.99,
        stock: ProductAvailability.outOfStock,
    },
    {
        ref: '004',
        name: 'Sapato de homem',
        size: '34',
        color: 'Preto',
        category: 'Calçado',
        price: 23,
        stock: ProductAvailability.inStock,
    },
    /* cspell:enable */
];

export const productCardDemo = {
    /* cspell:disable */
    uuid: '09876rfg',
    merchant: 'Roma Sapatarias',
    name: 'Sapato de mulher',
    image: 'https://picsum.photos/id/1080/632/632',
    price: 17.75,
    oldPrice: 35.5,
    initialFavorite: false,
    promo: 40,
    /* cspell:enable */
};

export const productCardLongTextDemo = {
    ...productCardDemo,
    /* cspell:disable */
    merchant: 'Roma Sapatarias Roma Sapatarias Roma Sapatarias Roma Sapatarias',
    name: 'Sapato de mulher Sapato de mulher Sapato de mulher Sapato de mulher',
    /* cspell:enable */
};

export const productsTaxonomyDemo = {
    /* cspell:disable */
    category: 'Vestuário, calçado e acessórios',
    subSubcategories: [
        {
            name: 'Malhas',
            image: 'https://picsum.photos/id/889/280/300',
        },
        {
            name: 'Pijamas',
            image: 'https://picsum.photos/id/889/280/300',
            active: true,
        },
        {
            name: 'Roupa de banho',
            image: 'https://picsum.photos/id/889/280/300',
        },
        {
            name: 'Roupa interior',
            image: 'https://picsum.photos/id/889/280/300',
        },
        {
            name: 'Saias',
            image: 'https://picsum.photos/id/889/280/300',
        },
        {
            name: 'Sapatos e sapatilhas e ténis',
            image: 'https://picsum.photos/id/889/280/300',
        },
        {
            name: 'Tops e bodies',
            image: 'https://picsum.photos/id/889/280/300',
        },
        {
            name: 'T-shirts',
            image: 'https://picsum.photos/id/889/280/300',
        },
        {
            name: 'Vestidos e macacões',
            image: 'https://picsum.photos/id/889/280/300',
        },
    ],
    /* cspell:enable */
};
